import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { ArrowRight, Home } from 'lucide-react';

export default function NotFound() {
  return (
    <div style={{ marginTop: '100px' }}>
      <Helmet>
        <title>Erreur 404 — Page introuvable | Nutri Centre Riviera</title>
        <meta name="robots" content="noindex, follow" />
      </Helmet>
      <section data-testid="not-found-section" style={{ padding: '7rem 0', textAlign: 'center', background: 'var(--bg-page)' }}>
        <div className="container" style={{ maxWidth: '680px' }}>
          <span style={{
            color: 'var(--accent-warm)',
            letterSpacing: '0.15em',
            textTransform: 'uppercase',
            fontWeight: 600,
            fontSize: '0.85rem',
            display: 'inline-block',
            marginBottom: '1rem'
          }}>
            Erreur 404
          </span>
          <h1 className="heading-1" style={{ marginBottom: '1.25rem' }}>
            Cette page est introuvable
          </h1>
          <p className="body-large" style={{ color: 'var(--text-muted)', marginBottom: '2.5rem', lineHeight: 1.7 }}>
            La page que vous cherchez n'existe pas ou a été déplacée. Retrouvez nos consultations, nos cabinets et nos conseils depuis la page d'accueil.
          </p>
          <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
            <Link to="/" className="btn-primary" data-testid="not-found-home-link">
              <Home size={18} />
              Retour à l'accueil
            </Link>
            <Link to="/consultations" className="btn-secondary" data-testid="not-found-consultations-link">
              Nos consultations
              <ArrowRight size={18} />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
